import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import { API_URL } from "../../../config";
import InvoiceBody from "./chalan_body";
import { currentDateTime, dateTimeFormat } from "../../../lib/functions";
import PrintIcon from "@material-ui/icons/Print";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import moment from "moment";
import ReactToPrint from "react-to-print";
import "./invoice.css";
import commaNumber from "comma-number";
import { Link } from 'react-router-dom';
import Button from "@material-ui/core/Button";
import { convertNumberToWords } from "../../../lib/functions";
let format = commaNumber.bindWith(",", ".");

class PrintAbleSection extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    sale: [],
    quantityByUnit: {},
  };

  componentDidMount() {
    this.getsale();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.saleId != this.props.saleId) {
      this.getsale();
    }
  }

  getsale = async () => {
    let customerId = null;
    await axios
      .post(
        `${API_URL}/api/get-sales-with-details`,
        { reqPayload: { saleId: this.props.saleId, from: "invoice" } },
        { headers: { "auth-token": this.props.authInfo.token } }
      )
      .then((res) => {
        if (res.data.message.length == 0) return false;
        let temp = {}
        res.data.message[0].details.forEach(item => {
          const unit = item.prod_unit_name;
          temp[unit] = (temp[unit] || 0) + item.sale_qty;
        });
        this.setState({
          quantityByUnit: temp,
          sale: res.data.message[0]
        })
        customerId = res.data.message[0].sale_customer_id;
      });
  };


  render() {
    let { sale, quantityByUnit } = this.state;
    let institution = this.props.institution
    return (
      <div style={{ padding: "10px" }}>
        {sale.length != 0 ? (
          <>
            <Grid container style={{ marginBottom: "30px", fontSize: "13px" }}>
              <Grid item xs={6} sm={8}>
                <strong>Customer ID : </strong>{" "}
                <span>{sale.customer_code}</span>
                <br />
                <strong>Customer Name : </strong>{" "}
                <span>{sale.customer_name}</span>
                <br />
                <strong>Institution Name : </strong>{" "}
                <span>{sale.customer_institution_name}</span>
                <br />
                <strong>Customer Address : </strong>{" "}
                <span>{sale.customer_address}</span>
                <br />
                <strong>Customer Mobile : </strong>{" "}
                <span>{sale.customer_mobile_no}</span>
                <br />
                <strong>PO No : </strong> <span>{sale.sale_po_id}</span>
                <br />
              </Grid>
              <Grid item xs={6} sm={4} style={{ textAlign: "left" }}>
                <strong>Sale By : </strong> <span style={{ textTransform: "uppercase" }}>{institution?.pro_name || " "}</span>
                <br />
                <strong>Ref By : </strong> <span>{sale.employee_name}</span>
                <br />
                <strong>Invoice No : </strong> <span>{sale.sale_invoice}</span>
                <br />
                <strong>Sale Date & Time :</strong>{" "}
                <span>
                  {moment(sale.sale_created_isodt).format(dateTimeFormat)}
                </span>
                <br />
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} sm={12}>
                <h3 className={"invoice-title"}>Challan</h3>
              </Grid>
            </Grid>

            <InvoiceBody saleData={sale} />
            <Grid container>
              <Grid xs={6} sm={6} style={{ marginTop: "2px" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td>Sub Total Quantity: </td>
                  </tr>
                </table>
              </Grid>
              <Grid xs={6} sm={6} style={{ marginTop: "2px" }}>
                <table style={{ width: "100%" }}>
                  {Object.entries(quantityByUnit).map(([unit, qty], index) => (
                    <tr key={unit}>
                      <td style={{ textAlign: "right" }}>{`${qty} ${unit}`}</td>
                    </tr>
                  ))}
                </table>
              </Grid>

              <Grid container>
                <Grid xs={2} sm={2}>
                  <table style={{ width: "100%" }}>
                    <tr>
                      <td style={{ textAlign: "left" }}>In Word:</td>
                    </tr>
                  </table>
                </Grid>
                <Grid xs={10} sm={10}>
                  <table style={{ width: "100%" }}>
                    {Object.entries(quantityByUnit).map(([unit, qty], index) => (
                      <tr key={unit}>
                        <td style={{ textAlign: "left" }}>{`${convertNumberToWords(qty)} ${unit}`}</td>
                      </tr>
                    ))}
                  </table>
                </Grid>
              </Grid>
              {!this.props.print && (
                <Grid item xs={12} style={{ textAlign: "right", marginTop: "20px" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      // Using state instead of window.location for SPA navigation (no reload)
                      this.props.history.push({
                        pathname: "/sales/sales-entry",
                        state: {
                          quotationData: sale,
                          fromQuotation: true
                        }
                      });
                    }}
                  >
                    Return to Sales Entry
                  </Button>
                </Grid>
              )}
            </Grid>
          </>
        ) : (
          ""
        )}
      </div>
    );
  }
}

class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    authInfo: this.props.authInfo,
    saleId: this.props.saleId,
  };

  render() {
    let institution = this.props.institution;
    let a4css = `
    .a4 {
      font-size: 14px;
      
  }
  .a4 body, table{
      font-size: 14px;
  }
    `;

    let hafa4css = `
    .hafa4 { 
      width:500px !important;
  }
  .hafa4 body, table{
      font-size: 14px;
  }
    `;

    let poscss = `
    .pos body{
      font-size: 10px;
  }
  .pos body, table{
      font-size: 10px;
  }
    `;

    return (
      <div className="print-source">
        {/* Print  DOCUMENT */}

        {
          /* {   A4 Print */
          institution != null && institution.pro_print_type == "a4" ? (
            <html lang="en">
              <head>
                <meta charset="UTF-8" />
                <meta
                  name="viewport"
                  content="width=device-width, initial-scale=1.0"
                />
                <meta http-equiv="X-UA-Compatible" content="ie=edge" />
                <title>Chalan Invoice</title>
                <style>{a4css}</style>
              </head>
              <body className="a4"
                style={{
                  paddingTop: "21mm",
                  paddingBottom: "0mm",
                  paddingLeft: "5mm",
                  paddingRight: "5mm",
                  position: "relative",
                }}
              >
                <div className="invoice-head">
                  {/* <div className="invoice-logo">
                    <image
                      alt="logo"
                      src={`${API_URL}/${institution.pro_logo}`}
                      style={{ width: "100px", height: "100px" }}
                    />
                  </div>
                  <div className="invoice-desc">
                    <h2>{institution.pro_name}</h2>
                    <p>{institution.pro_desc}</p>
                  </div> */}
                </div>

                <PrintAbleSection
                  authInfo={this.state.authInfo}
                  saleId={this.props.saleId}
                  institution={institution}
                  print={true}
                />
                {/* <div
                  style={{
                    position: "fixed",
                    bottom: "0px",
                    width: "100%",
                    padding: "5px",
                  }}
                >
                  <div className="invoice-footer">
                    <p
                      style={{
                        float: "left",
                        borderTop: "1px solid #222",
                        width: "150px",
                        textAlign: "center",
                      }}
                    >
                      Received By
                    </p>

                    <p
                      style={{
                        float: "right",
                        marginRight: "10px",
                        borderTop: "1px solid #222",
                        width: "150px",
                        textAlign: "center",
                      }}
                    >
                      Authorized By
                    </p>
                  </div>
                  <div className="invoice-footer-bottom">
                    <p style={{ float: "left" }}>
                      Print Date & Time :{" "}
                      {moment(currentDateTime).format(dateTimeFormat)}
                    </p>
                    <p style={{ float: "right", marginRight: "10px" }}>
                      Developed By : DeshIT-BD | Contact No = 01813320587
                    </p>
                  </div>
                </div> */}
              </body>
            </html>
          ) : (
            ""
          )
        }

        {
          /* {  1/2 - A4   Print */
          institution != null && institution.pro_print_type == "1/2a4" ? (
            <html lang="en">
              <head>
                <meta charset="UTF-8" />
                <meta
                  name="viewport"
                  content="width=device-width, initial-scale=1.0"
                />
                <meta http-equiv="X-UA-Compatible" content="ie=edge" />
                <title>Sales Invoice</title>
                <style>{hafa4css}</style>
              </head>
              <body className="hafa4" style={{
                paddingTop: "12mm",
                paddingBottom: "0mm",
                paddingLeft: "2.5mm",
                paddingRight: "2.5mm",
                position: "relative",
              }}>
                {/* <div className="invoice-head" style={{ width: "500px" }}>
                  <div
                    className="invoice-logo"
                    style={{ width: "10%", float: "left" }}
                  >
                    <image
                      alt="logo"
                      src={`${API_URL}/${institution.pro_logo}`}
                      style={{ width: "100px", height: "100px" }}
                    />
                  </div>
                  <div
                    className="invoice-desc"
                    style={{ width: "80%", float: "right" }}
                  >
                    <h2>{institution.pro_name}</h2>
                    <p>{institution.pro_desc}</p>
                  </div>
                </div> */}

                <PrintAbleSection
                  authInfo={this.state.authInfo}
                  saleId={this.props.saleId}
                  institution={institution}
                  print={true}
                />
                {/* <div
                  style={{
                    position: "fixed",
                    bottom: "0px",
                    width: "500px",
                    padding: "5px",
                  }}
                >
                  <div className="invoice-footer">
                    <p
                      style={{
                        float: "left",
                        borderTop: "1px solid #222",
                        width: "150px",
                        textAlign: "center",
                      }}
                    >
                      Received By
                    </p>

                    <p
                      style={{
                        float: "right",
                        marginRight: "10px",
                        borderTop: "1px solid #222",
                        width: "150px",
                        textAlign: "center",
                      }}
                    >
                      Authorized By
                    </p>
                  </div>
                  <div
                    className="invoice-footer-bottom"
                    style={{ width: "500px" }}
                  >
                    <p style={{ float: "left" }}>
                      Print Date & Time :{" "}
                      {moment(currentDateTime).format(dateTimeFormat)}
                    </p>
                    <p style={{ float: "left", marginRight: "10px" }}>
                      Developed By : DeshIT-BD | Contact No = 01813320587
                    </p>
                  </div>
                </div> */}
              </body>
            </html>
          ) : (
            ""
          )
        }

        {
          /* {   A4 Print */
          institution != null && institution.pro_print_type == "pos" ? (
            <html lang="en">
              <head>
                <meta charset="UTF-8" />
                <meta
                  name="viewport"
                  content="width=device-width, initial-scale=1.0"
                />
                <meta http-equiv="X-UA-Compatible" content="ie=edge" />
                <title>Sales Invoice</title>
                <style>{poscss}</style>
              </head>
              <body className="pos" style={{ padding: "5px" }}>
                {/* <div className="invoice-head">
                  <div className="invoice-logo">
                    <image
                      alt="logo"
                      src={`${API_URL}/${institution.pro_logo}`}
                      style={{ width: "100px", height: "100px" }}
                    />
                  </div>
                  <div className="invoice-desc">
                    <h2>{institution.pro_name}</h2>
                    <p>{institution.pro_desc}</p>
                  </div>
                </div> */}

                <PrintAbleSection
                  authInfo={this.state.authInfo}
                  saleId={this.props.saleId}
                  institution={institution}
                  print={true}
                />
                {/* <div
                  style={{
                    position: "fixed",
                    bottom: "0px",
                    width: "100%",
                    padding: "5px",
                  }}
                >
                  <div className="invoice-footer">
                    <p
                      style={{
                        float: "left",
                        borderTop: "1px solid #222",
                        width: "150px",
                        textAlign: "center",
                      }}
                    >
                      Received By
                    </p>

                    <p
                      style={{
                        float: "right",
                        marginRight: "10px",
                        borderTop: "1px solid #222",
                        width: "150px",
                        textAlign: "center",
                      }}
                    >
                      Authorized By
                    </p>
                  </div>
                  <div className="invoice-footer-bottom">
                    <p style={{ float: "left" }}>
                      Print Date & Time :{" "}
                      {moment(currentDateTime).format(dateTimeFormat)}
                    </p>
                    <p style={{ float: "right", marginRight: "10px" }}>
                      Developed By : DeshIT-BD | Contact No = 01813320587
                    </p>
                  </div>
                </div> */}
              </body>
            </html>
          ) : (
            ""
          )
        }
      </div>
    );
  }
}

let SalesInvoice = ({ authInfo, saleId, institution, history }) => {
  let componentRef = useRef();

  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={8} className={"invoice-section"}>
          {/* Main Grid Start */}
          <div>
            <Button
              variant="outlined"
              size="small"
              startIcon={<ArrowBackIcon />}
              style={{ marginRight: "10px", marginBottom: "5px" }}
              onClick={() => {
                if (window.history.length > 1) {
                  history.goBack();
                } else {
                  history.push("/sales/sales-record");
                }
              }}
            >
              Back
            </Button>
            <ReactToPrint
              trigger={() => <PrintIcon style={{ cursor: "pointer" }} />}
              content={() => componentRef}
            />

            <ComponentToPrint
              ref={(el) => (componentRef = el)}
              authInfo={authInfo}
              saleId={saleId}
              institution={institution}
            />

            <PrintAbleSection authInfo={authInfo} saleId={saleId} institution={institution} history={history} print={false} />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

const mapStateToPops = (state) => {
  return {
    authInfo: state.authInfoReducer,
  };
};
export default connect(mapStateToPops, {})(SalesInvoice);
